import React from 'react';

import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Col, Row, Divider, Typography, Spin } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useClickCollect from '../useClickCollect';

const MainPage = () => {
  const { t } = useTranslation();
  const { data, loading, openLinkInNewTab } = useClickCollect();

  return (
    <>
      <PageHeader title={t('INSEGNE SMART SHOPPING').toUpperCase()}>
        <Row gutter={16}><Divider /></Row>
      </PageHeader>
      <div className={styles.container}>
        <Row gutter={16}>
          {!loading ? data.records.map(record => (
            <Col key={record.id} className={styles.shoppingCenters}>
              <Typography.Title level={4}>{record.shopping_center.title}</Typography.Title>
              <Button
                type={'primary'}
                width={'200px'}
                onClick={openLinkInNewTab(record.shopping_center.id)}
              >
                {t('SMART SHOPPING')} <ArrowRightOutlined />
              </Button>
              <ul className={styles.companyList}>
                {record.shopping_center.companies.map(company => (
                  <li key={company.id}>{company.short_name}</li>
                ))}
              </ul>
            </Col>
          )) : <Spin size={'large'} />}
        </Row>
      </div>
    </>
  );
};

export default MainPage;
